/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const es_nw_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio`)
};

const de_nw_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startseite`)
};

const nl_nw_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const fr_nw_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accueil`)
};

const it_nw_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const pt_br2_nw_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início`)
};

const pt_nw_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início`)
};

const ja_nw_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホーム`)
};

const zh_nw_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首页`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_breadcrumb_home = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_breadcrumb_home(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_breadcrumb_home", locale)
	if (locale === "en") return en_nw_breadcrumb_home(inputs)
	if (locale === "es") return es_nw_breadcrumb_home(inputs)
	if (locale === "de") return de_nw_breadcrumb_home(inputs)
	if (locale === "nl") return nl_nw_breadcrumb_home(inputs)
	if (locale === "fr") return fr_nw_breadcrumb_home(inputs)
	if (locale === "it") return it_nw_breadcrumb_home(inputs)
	if (locale === "pt-BR") return pt_br2_nw_breadcrumb_home(inputs)
	if (locale === "pt") return pt_nw_breadcrumb_home(inputs)
	if (locale === "ja") return ja_nw_breadcrumb_home(inputs)
	return zh_nw_breadcrumb_home(inputs)
};